import { render, staticRenderFns } from "./Bottomcontent.vue?vue&type=template&id=08950bec&scoped=true&"
import script from "./Bottomcontent.vue?vue&type=script&lang=js&"
export * from "./Bottomcontent.vue?vue&type=script&lang=js&"
import style0 from "@/assets/bottomcontent.css?vue&type=style&index=0&id=08950bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08950bec",
  null
  
)

export default component.exports